<template>
  <main class="border-to-navi" v-if="deal">
    <!-- Superbanner -->
    <template>
      <portal to="superbanner">
        <div id="stroeerDealPageSuperbannerArea" class="banner"></div>
      </portal>
    </template>

    <!-- vv Stroeer Sticky Footer vv -->
    <!-- <div
      v-if="['de', 'at', 'ch'].includes($i18n.locale)"
      id="right-content6"
      ref="right-content6"
      class="banner ads-spacing"
    /> -->
    <!-- ^^ Stroeer Sticky Footer ^^ -->

    <FeaturedImages
      :loading="$apollo.loading"
      :deal-id="deal && deal.id"
      :featured-images="deal && deal.featuredImages"
      :is-mobile="isMobile"
    />

    <section class="section deal-content-wrapper content-container">
      <div class="deal-heading">
        <!-- Deal Title -->
        <HgDealTitle
          v-if="deal"
          :loading="$apollo.loading"
          :badge="deal && deal.badge"
          :title="deal && deal.title"
          :subtitle="deal && deal.subtitle"
        />
        <HgDealTitle v-else :loading="true" title="..." subtitle="..." />
        <client-only>
          <HgCancellationBadge
            v-if="isMobile && providerConditionBadges.length"
            :badges="providerConditionBadges"
            is-mobile
            class="tw-mt-4"
          />
        </client-only>
      </div>

      <!-- Left -->
      <div class="content deal-content">
        <HgDealDetailSkeleton v-if="!deal" />
        <template v-else>
          <!-- Deal Description -->
          <DealContent
            :content="deal.content"
            :forwarder-content="deal.forwarderContent"
            :create-date="deal.createDate"
            :publish-date="deal.publishDate"
            :user="deal.user"
          />

          <!-- Deal Footer -->
          <HgDealFooter
            class="deal-footer-wrap mt-6"
            :screenshots="deal && deal.screenshots"
            @onOpenScreenshots="clickScreenshotButton"
          />

          <!--
            Adup Banner Section
            ONLY FOR ES
          -->
          <template v-if="adupLoaded && allowAdup">
            <client-only>
              <dealDetailMiddleContentAdES
                query="deal_detail_query"
                :locale="$i18n.locale"
              />
            </client-only>
          </template>
        </template>
        <!-- Adup Banner -->
        <template>
          <LeaderboardBanner
            v-if="
              adupLoaded &&
                allowAdup &&
                ['de', 'ch', 'at'].includes($i18n.locale)
            "
            :key="'ad-' + 0"
            :element-id="0"
            :query="deal.title"
          />
        </template>
      </div>

      <!-- Right -->
      <div v-if="deal === null" class="deal-box">
        <HgDealBoxSkeleton />
      </div>
      <div v-if="deal" class="deal-box">
        <client-only>
          <HgDealBoxTravelBasic
            :is-mobile="isMobile"
            :deal-id="deal.id"
            :deal-expiry-date="deal.expiryDate"
            :deal-price-currency="deal.price.currency"
            :deal-price-value="deal.price.value"
            :deal-price-forwarder-url="deal.price.forwarderUrl"
            :deal-price-url="deal.price.url"
            :deal-highlights="deal.highlights"
            :deal-type-label="deal.__typename"
            :deal-number-of-adults="deal.travelInformation.numberOfAdults"
            :deal-duration="deal.travelInformation.duration"
            :deal-vouchers="deal.vouchers"
            :deal-bookmark="deal.bookmark"
            :show-price-per-date="showPricePerDate"
            :round-calendar-prices="roundCalendarPrices"
            :round-deal-price="roundDealPrice"
            :deal-provider-cancellation-conditions="
              deal.providerCancellationConditions || []
            "
            @onBookingUrlClick="clickUrl"
            @onClickShare="clickShare(deal)"
            @onClickBookmark="clickBookmark(deal)"
          />
          <HgDealSupportBox
            v-if="!isMobile"
            class="support-box"
            :show-phone="showSupportPhone"
            :show-mail="showSupportMail"
            :mail-subject="`${$t('supportPerson.mailSubject')} ${deal.id}`"
            :deal-id="deal.id"
            :image-src="supportImageSrc"
            :is-mobile="isMobile"
          />
          <div class="alert-container">
            <HgAlertBox v-if="hasProviderConditions" type="flat-info">
              <HgEditorContent
                class="tw-text-sm"
                :content="deal.providerCancellationConditions[0].condition"
              />
            </HgAlertBox>
          </div>
        </client-only>
      </div>
      <div v-if="isMobile && deal" class="support-box">
        <client-only>
          <HgDealSupportBox
            :show-phone="showSupportPhone"
            :show-mail="showSupportMail"
            :mail-subject="`[Deal-ID: ${deal.id}]`"
            :deal-id="deal.id"
            :image-src="supportImageSrc"
            :is-mobile="isMobile"
          />
        </client-only>
      </div>

      <!-- Stroeer Banner -->
      <div v-if="deal" class="support-banner">
        <div
          id="stroeerDealPageSidebarArea"
          class="tw-relative tw-z-50 banner"
        ></div>
      </div>
    </section>

    <!-- Related Deals -->
    <template v-if="deal && deal.relatedDeals.length">
      <RelatedDealsSection :deals="deal.relatedDeals" />
    </template>

    <!-- Related Magazine Articles -->
    <template
      v-if="
        deal &&
          deal.relatedWordpressMagazine &&
          deal.relatedWordpressMagazine.length
      "
    >
      <RelatedMagazineSection
        :magazine-cards="deal.relatedWordpressMagazine"
        :is-mobile="isMobile"
      />
    </template>

    <!-- Newsletter -->
    <NewsletterSection />

    <!--
      Adup Banner Section
      ONLY FOR ES
    -->
    <template v-if="adupLoaded && allowAdup">
      <client-only>
        <dealDetailBottomContentAdES
          class="content-container content-container--spacing ads-spacing"
          query="deal_detail_query"
          :locale="$i18n.locale"
        />
      </client-only>
    </template>

    <div id="stroeerDealPageMediumRectangleArea" class="banner"></div>
    <!-- Link List (SEO) -->
    <LinkListSection class="section-spacing" />

    <!-- Stroeer -->
    <client-only>
      <StroeerLoader />
    </client-only>

    <!-- Infonline -->
    <template v-if="$i18n.locale === 'de'">
      <Infonline cp="content" sv="i2" />
    </template>
  </main>
  <main v-else>
    <HgDealDetailSkeleton />
  </main>
</template>

<script>
import getTravelBasicDealQuery from '@/apollo/queries/deal/getTravelBasicDeal';
import previewDealQuery from '@/apollo/queries/deal/previewDeal';
import DealPageMixin from '@/mixins/DealPageMixin';
import AdSlotsMixin from '@/mixins/AdSlotsMixin';

import dealDetailMiddleContentAdES from '@/components/ads/adup/ES/deal-detail/dealDetailMiddleContentAdES.vue';
import dealDetailBottomContentAdES from '@/components/ads/adup/ES/deal-detail/dealDetailBottomContentAdES.vue';

export default {
  components: {
    Infonline: () => import('@/components/tracking/Infonline.vue'),
    dealDetailMiddleContentAdES,
    dealDetailBottomContentAdES
  },
  mixins: [DealPageMixin, AdSlotsMixin],
  asyncData({ params, query, req }) {
    const slug = params.slug; // When calling /abc the slug will be "abc"

    return {
      slug,
      dealKey: 'getTravelBasicDeal'
    };
  },
  data: () => ({
    deal: null
  }),

  apollo: {
    getTravelBasicDeal: {
      query: getTravelBasicDealQuery,
      prefetch: true,
      errorPolicy: 'all',
      variables() {
        const id = this.slug.substring(this.slug.length - 36); // UUID (36 chars)

        return {
          id,
          origin: this.origin
        };
      },
      skip() {
        return this.$route.query.token != null;
      },
      result({ data }) {
        const dealData = data[this.dealKey];

        if (!dealData || dealData.status === 'TRASH') {
          this.$nuxt.error({
            statusCode: 404,
            message: 'Deal not found',
            relatedDeals: dealData != null ? dealData.relatedDeals : []
          });
        } else {
          this.deal = dealData;
        }
      }
    },
    previewDeal: {
      query: previewDealQuery,
      prefetch: true,
      errorPolicy: 'all',
      variables() {
        return {
          token: this.$route.query.token
        };
      },
      skip() {
        return this.$route.query.token == null;
      },
      result(result) {
        const dealData = result.data.previewDeal;

        if (!dealData || dealData.status === 'TRASH') {
          this.$nuxt.error({
            statusCode: 404,
            message: 'Deal not found',
            relatedDeals: dealData != null ? dealData.relatedDeals : []
          });
        } else {
          this.deal = dealData;
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../deal-page.styles.css';
@import '../banner.styles.css';

.section-spacing {
  margin-top: rem(40);

  @media (max-width: 768px) {
    margin-top: rem(80);
  }
}

.deal-footer-wrap {
  margin-bottom: 16px;
}
</style>
